import { render } from "./Pulse.vue?vue&type=template&id=788b0762"
import script from "./Pulse.vue?vue&type=script&lang=ts"
export * from "./Pulse.vue?vue&type=script&lang=ts"
script.render = render

export default script